import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { getCSSColorBg } from '~/utilities/getCSS';
import type { COLOR } from '~/types/AppData/Theme/ColorInterface';

const separatorClasses = cva('h-[1px] grow', {
  variants: {
    color: getCSSColorBg(),
  },
});

export default component$(({ color }: { color: COLOR }): JSX.Element => {
  return (
    <div
      class={separatorClasses({
        color,
      })}
    ></div>
  );
});
